import { registerPlugin } from '@capacitor/core';
const CMFilemanager = registerPlugin('CMFilemanager', {
    web: () => import('./web').then(m => new m.CMFilemanagerWeb()),
});
export * from './definitions';
export { CMFilemanager };
//# sourceMappingURL=index.js.map